import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Houma, LA?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Houma can take 2–6 months, especially during busy travel seasons. For offshore workers, fishing industry travelers, and families planning Caribbean trips, that timeline is simply not viable.",
  },
  {
    q: "Can offshore workers in Houma get an expedited passport quickly?",
    a: "Absolutely. Offshore oil and gas workers are one of our most common client types in Houma. Rig rotations often change with little notice, and international assignments to West Africa, the North Sea, or Brazil require valid passports. We regularly process expedited renewals and new applications for offshore workers on compressed timelines. Contact us as soon as your rotation schedule is confirmed.",
  },
  {
    q: "What if my passport expires before a fishing industry trip to the Caribbean?",
    a: "This happens more often than you would think, especially for commercial fishing operators and seafood exporters traveling to Caribbean markets. Most destinations require your passport to be valid for at least six months beyond your return date. If your expiration is cutting it close, we strongly recommend expedited processing. Standard mail-in renewal through a Houma post office typically takes 2–6 months — far too long for an upcoming trip.",
  },
  {
    q: "Can families in Thibodaux and Schriever get expedited passports?",
    a: "Yes. Families throughout Terrebonne and Lafourche Parishes have the same access to our expedited services as Houma residents. Since we operate remotely, your physical location in the bayou region does not affect processing speed. Ship your documents overnight from anywhere in the area, and we handle the rest. Most clients in the Houma-Thibodaux metro area receive their passports within 2–9 business days.",
  },
  {
    q: "How quickly can travelers in Gray and Bourg receive an expedited passport?",
    a: "Gray, Bourg, and surrounding communities have the same access to our expedited services as Houma residents. Since we operate remotely, your physical location in Terrebonne Parish does not affect processing speed. Ship your documents overnight, and we handle the rest. Most clients in the Houma area receive their passports within 2–9 business days.",
  },
  {
    q: "Can commercial fishing industry workers expedite a passport renewal?",
    a: "Yes — commercial fishing operators, seafood processors, and dock workers from Houma, Dulac, and Montegut are well within our service area. Whether you are traveling to trade shows in Europe, visiting buyers in Asia, or taking a family vacation, we make the renewal process straightforward. You do not need to drive to New Orleans for a passport agency appointment. Start online, ship your documents, and we handle the expedited submission.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Houma travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Houma, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in Terrebonne Parish or the bayou region.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function HoumaFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Houma and bayou region travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}